export const version = '1.7.0';
//# sourceMappingURL=version.js.map